import { useState, useRef, useEffect, useCallback, useMemo, memo } from 'react'
import { deleteUserInfo } from '../../../api/orderHistory'
import { PaymentInfoItem } from '../../../@types/order'
import { useCommonContext } from '../../provider/CommonProvider'

interface AFPayOptionLayerProps {
  payUserRegister: string
  cardInfos: PaymentInfoItem[]
  setCardDelete: React.Dispatch<React.SetStateAction<boolean>>
  setChangePayData: React.Dispatch<React.SetStateAction<boolean>>
  setCardInfos: React.Dispatch<React.SetStateAction<PaymentInfoItem[]>>
  deleteModal: boolean
  setDeleteModal: React.Dispatch<React.SetStateAction<boolean>>
}

function AFPayOptionLayer({
  payUserRegister,
  cardInfos,
  setCardDelete,
  setChangePayData,
  setCardInfos,
  deleteModal,
  setDeleteModal,
}: AFPayOptionLayerProps) {
  const [isShowAFOptionLayer, setIsShowAFOptionLayer] = useState(false)
  const { hasAccessToken } = useCommonContext()
  const layerRef = useRef<HTMLDivElement>(null)

  // 옵션 버튼 핸들러
  const handleAfOptionToggle = useCallback(() => {
    setIsShowAFOptionLayer((prev) => !prev)
  }, [])

  // 탈퇴 처리 핸들러
  const handleWithdraw = useCallback(async () => {
    const confirmed = window.confirm('탈퇴하시겠습니까?')
    if (!confirmed) return
    try {
      await deleteUserInfo()
      alert('어바웃피싱 페이에서 탈퇴하셨습니다.')
      setCardDelete((prev) => !prev)
      setChangePayData((prev) => !prev)
      setCardInfos([])
    } catch (err) {
      console.log(err)
    }
  }, [setCardDelete, setChangePayData, setCardInfos])

  // 카드 삭제 핸들러
  const handleCardDelete = useCallback(() => {
    setDeleteModal((prev) => !prev)
  }, [setDeleteModal])

  // 외부 클릭 시 옵션 레이어 닫기
  useEffect(() => {
    if (!isShowAFOptionLayer) return
    const handleClickOutside = (e: MouseEvent) => {
      if (deleteModal) return
      if (layerRef.current && !layerRef.current.contains(e.target as Node)) {
        setIsShowAFOptionLayer(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isShowAFOptionLayer, deleteModal])

  const renderAfOptionLayer = useMemo(
    () => (
      <div className='pay_layer'>
        <ul>
          <li>
            <button className='pay_withdraw' onClick={handleWithdraw}>
              페이탈퇴
            </button>
          </li>
          {cardInfos.length > 0 && (
            <li>
              <button className='card_delete' onClick={handleCardDelete}>
                카드삭제
              </button>
            </li>
          )}
        </ul>
      </div>
    ),
    [handleWithdraw, handleCardDelete, cardInfos.length]
  )

  if (payUserRegister !== '0000' || !hasAccessToken) return null
  return (
    <div ref={layerRef}>
      <button className='af_option_btn' onClick={handleAfOptionToggle}>
        <i></i>
        <i></i>
        <i></i>
      </button>
      {isShowAFOptionLayer && renderAfOptionLayer}
    </div>
  )
}

export default memo(AFPayOptionLayer)
